<template>
    <v-container>
        <v-row>
            <v-col>
                <v-toolbar dense color="secondary" elevation="1" rounded>
                    <v-breadcrumbs class="ms-n6" :items="[
                        {text: 'Warehouse & Inventory'},
                        {text: 'Warehouse'},
                        {text: 'Create Warehouse Item'}
                    ]" large/>
                </v-toolbar>
            </v-col>
        </v-row>
        <v-row>
            <v-col md="6">
                <v-sheet elevation="1" rounded>
                    <v-toolbar flat color="secondary">
                        <v-toolbar-title>
                            Create Warehouse Item
                        </v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-toolbar-items>
                            <v-btn icon @click="handleSave">
                                <v-icon>mdi-content-save</v-icon>
                            </v-btn>
                        </v-toolbar-items>
                    </v-toolbar>
                    <v-divider></v-divider>
                    <v-progress-linear indeterminate v-if="loading"/>
                    <div class="pa-3">
                        <WarehouseItemForm ref="form" v-model="data" v-if="!fetchLoading"/>
                        <WarehouseItemLoader v-else/>
                    </div>
                </v-sheet>
            </v-col>
        </v-row>
        <PAlert v-model="alert.value" v-bind="alert"/>
    </v-container>
</template>

<script>
import { mapActions } from 'vuex';
import WarehouseItemForm from './../../components/warehouse/WarehouseItemForm';
import WarehouseItemLoader from './../../components/warehouse/WarehouseItemLoader';
import PAlert from './../../components/common/PAlert';
import { v4 as uuid } from 'uuid';

export default {
    name: "WarehouseItemCreateView",
    components: {
        WarehouseItemForm,
        WarehouseItemLoader,
        PAlert
    },
    data() {
        return {
            warehouseId: null,
            loading: false,
            data: null,
            fetchLoading: false,
            idempotentKey: null,
            alert: {
                value: false,
                title: "Alert",
                content: "Are you sure?",
                callback: null
            },
        }
    },
    methods: {
        ...mapActions({
            warehouseFindByID: "warehouse/warehouse/findByID",
            pushWarehouse: "warehouse/warehouse/search/push",
            snackbar: "ui/snackbar/show",
            create: "stock/warehouseItem/create"
        }),
        handleSave() {
            this.alert = {...this.alert, value: true, content: "Are you sure you want to Save?", callback: this.saveAsnyc};
        },
        saveAsnyc() {
            if(!this.$refs.form.validate()) return;
            this.loading = true;
            this.create({...this.data, idempotentKey: this.idempotentKey}).then(() => {
                this.$router.push({name: "WarehouseItemList", query: { warehouseId: this.data.warehouse_id }})
                this.snackbar({ text: "Warehouse Item Created", color: "success"})
            }).catch(error => {
                let message = error.response ? error.response.data.message : error
                this.snackbar({ text: message, color: "error"})
            }).finally(() => {
                this.loading = false
            })
        },
        // fetchWarehouseAsync() {
        //     this.fetchLoading = true;
        //     this.warehouseFindByID(this.warehouseId).then(response => {
        //         this.data = {}
        //         this.data.warehouse_id = response.data.id;
        //         this.pushWarehouse(response.data);
        //     }).catch(error => {
        //         let message = error.response ? error.response.data.message : error
        //         this.snackbar({ text: message, color: "error"})
        //     }).finally(() => {
        //         this.fetchLoading = false
        //     })

        // }
    },
    // mounted() {
    //     this.warehouseId = this.$route.params.warehouseId;
    //     this.fetchWarehouseAsync();
    // },
    created() {
        this.idempotentKey = uuid();
    }

}
</script>

<style>

</style>